import { ApiErrorResponse } from 'types/errors'

export const getRequestErrors = (requestError: ApiErrorResponse) =>
  requestError?.data?.details?.errors
